import { CATEGORIES, ContentNode, HANDLER_TYPES } from 'craft/types';

export const dismissLabelAdapter = (eventName: string) => (node: ContentNode): ContentNode => {
  if (node?.props?.isDismissible !== true) {
    return node;
  }
  const actions = node.data?.actions || [];
  if (actions.find((action) => action.category === CATEGORIES.DISMISS)) {
    return node;
  }
  return {
    ...node,
    data: {
      ...node.data,
      actions: [
        ...(node.data?.actions || []),
        {
          category: CATEGORIES.DISMISS,
          handler: {
            type: HANDLER_TYPES.DISMISS,
          },
          eventName,
        },
      ],
    },
  };
};
